var Flickity = require('flickity-imagesloaded');

class Slider {
    constructor(selector, options) {
        this._selector = selector;
        this._options = options || {
                dots: false,
                speed: 500,
                cellAlign: 'center'
            };

        this.init();
    }

    init() {
        $.when(
            this.flkty = new Flickity(this._selector, this._options)
        ).then(()=> {
            this.$fickityInstance = $(this.flkty.element);

            this.$fickityInstance.parent().find('.js-slider-next').on('click', () => {
                this.flkty.next(true, false);
            });

            this.$fickityInstance.parent().find('.js-slider-prev').on('click', () => {
                this.flkty.previous(true, false);
            });
        });

        this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
            if (typeof cellIndex == 'number') {
                this.flkty.select(cellIndex, true, false);
            }
        });
    }
}

module.exports = Slider;